'use es6';

import { getPaneNameFromPath } from 'ContentEditorUI/utils/helpers';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { parseQueryString } from 'ContentEditorUI/utils/routeHelper';
import { getFullUrl } from 'hubspot-url-utils';
import getHistory from 'ContentEditorUI/redux/getHistory';
import EditorConfigSingleton from '../../EditorConfigSingleton';
export const getHost = basicSelector(() => getFullUrl('app'));
export const getRoutingLocation = () => getHistory() ? getHistory().location : null;
const createRoutingSelector = field => {
  return basicSelector(() => {
    const routingLocation = getRoutingLocation();
    if (!routingLocation) {
      return '';
    }
    return routingLocation[field];
  });
};
export const getRoutingPathname = createRoutingSelector('pathname');
export const getRoutingQueryParams = basicSelector(() => {
  const routingLocation = getRoutingLocation();
  if (!routingLocation) {
    return {};
  }
  const queryString = routingLocation.search;
  return parseQueryString(queryString);
});
export const getRoutingHash = createRoutingSelector('hash');
export const getRoutingKey = createRoutingSelector('key');
export const getRoutingCurrentPage = basicSelector(() => {
  const routingPathName = getRoutingPathname();
  return getPaneNameFromPath(routingPathName);
});

// TODO branden eventually replace getRoutingCurrentPage?
export const getCurrentTabId = basicSelector(() => {
  const routingPathName = getRoutingPathname();
  return getPaneNameFromPath(routingPathName);
});
export const getRoutingRelativePath = basicSelector(() => {
  const pathname = getRoutingPathname();
  if (pathname.split('/').length > 3 || EditorConfigSingleton.getIsOnScalableEditor() && pathname.split('/').length > 2) {
    return pathname.substring(0, pathname.lastIndexOf('/') + 1);
  }
  return pathname.endsWith('/') ? pathname : `${pathname}/`;
});
export const getRoutingLocationFromRedux = basicSelector(state => state.__location);
export const getIsEmbeddedEmailEditorRoute = basicSelector(() => {
  const pathname = getRoutingPathname();
  return pathname.includes('edit-csp');
});

/**
 * Full routes with "editor":
 * https://app.hubspotqa.com/blog/862742022/editor/191639331182/content
 * https://app.hubspotqa.com/pages/862742022/editor/191671966340/content
 * https://app.hubspotqa.com/case-study/862742022/editor/191937452850
 * https://app.hubspotqa.com/podcasts/862742022/editor/63038726248/audio
 *
 * Full routes with "edit":
 * https://app.hubspotqa.com/email/862742022/edit/189889649789/content
 * https://app.hubspotqa.com/sms/862742022/edit/192134174563/content
 */
export const getRoutingContentId = basicSelector(() => {
  var _parts$find;
  const pathname = getRoutingPathname();
  if (!pathname) {
    return null;
  }
  const parts = pathname.split('/');

  // /edit/192136441727/content -> 192136441727
  // /192137875584/content -> 192137875584
  return (_parts$find = parts.find(part => {
    const num = parseInt(part, 10);
    return !isNaN(num) && num >= 0 && num.toString() === part;
  })) !== null && _parts$find !== void 0 ? _parts$find : null;
});